import { Divider as BaseDivider } from '@material-ui/core'
import React from 'react'

import { Panel } from './Panel'
import { PlanBillingProvider } from '../usePlanBillingContext'

export const Divider = (props) => <BaseDivider className="my-24" {...props} />

export default function Content() {
  return (
    <PlanBillingProvider>
      <div className="space-y-20">
        <Panel />
      </div>
    </PlanBillingProvider>
  )
}
